import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const FileDocument = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m13.29 3.57.532-.528zm5.144 5.184.533-.528zm-9.572 3.712a.75.75 0 0 0 0 1.5zm3.38 1.5a.75.75 0 0 0 0-1.5zm-3.38 2.392a.75.75 0 0 0 0 1.5zm6.276 1.5a.75.75 0 0 0 0-1.5zM6.93 3.75h4.993v-1.5H6.931zm11.319 6.38v8.924h1.5V10.13zm-5.493-6.032 5.145 5.185 1.065-1.057-5.145-5.184zM5.75 19.054V4.946h-1.5v14.108zm11.319 1.196H6.931v1.5h10.138zM4.25 19.054a2.69 2.69 0 0 0 2.681 2.696v-1.5c-.647 0-1.181-.53-1.181-1.196zm15.5-8.924c0-.713-.281-1.398-.783-1.904l-1.065 1.057c.222.224.348.528.348.847zm-7.826-6.38c.312 0 .611.125.833.348l1.065-1.056a2.67 2.67 0 0 0-1.898-.792zm6.326 15.304c0 .666-.534 1.196-1.181 1.196v1.5a2.69 2.69 0 0 0 2.681-2.696zM6.931 2.25A2.69 2.69 0 0 0 4.25 4.946h1.5c0-.666.534-1.196 1.181-1.196zm5.043 1.236v3.892h1.5V3.486zm2.681 6.588h3.862v-1.5h-3.862zm-2.68-2.696a2.69 2.69 0 0 0 2.68 2.696v-1.5c-.647 0-1.18-.53-1.18-1.196zm-3.113 6.588h3.38v-1.5h-3.38zm0 3.892h6.276v-1.5H8.862z'
        fill='currentColor'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.974 7.378V2.25H6.931A2.69 2.69 0 0 0 4.25 4.946v14.108a2.69 2.69 0 0 0 2.681 2.696h10.138a2.69 2.69 0 0 0 2.681-2.696v-8.98h-5.095a2.69 2.69 0 0 1-2.68-2.696m1.5 0V2.746q.185.132.348.296l5.145 5.184q.161.163.291.348h-4.603c-.647 0-1.18-.53-1.18-1.196m-4.612 5.088a.75.75 0 0 0 0 1.5h3.38a.75.75 0 0 0 0-1.5zm0 3.892a.75.75 0 0 0 0 1.5h6.276a.75.75 0 0 0 0-1.5z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
